<script setup lang="ts">
import MediaLibrary from '@/modules/media-library/components/MediaLibrary.vue';

const props = defineProps<{ jobBoardId: number }>();
</script>

<template>
   <MediaLibrary :jobBoardId="props.jobBoardId" />
</template>
